import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { AssessmentIcon } from "@/lib/icons";

export function AssessmentCard({ a, status, to }) {
  const completed = status === "completed";
  return (
    <Link
      to={to || `/a/${a.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-slate-800 bg-slate-900 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-slate-700"
      data-testid={`assessment-card-${a.slug}`}
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full opacity-20 blur-2xl transition-opacity group-hover:opacity-40" style={{ background: a.color }} />
      <div className="relative flex items-start justify-between">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl" style={{ background: `${a.color}1a`, color: a.color }}>
          <AssessmentIcon name={a.icon} size={22} weight="duotone" />
        </span>
        {completed ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-teal-500/15 px-2.5 py-1 text-[11px] font-medium text-teal-300">
            <CheckCircle size={12} weight="fill" /> Completed
          </span>
        ) : (
          <span className="rounded-full border border-slate-700 px-2.5 py-1 text-[11px] text-slate-500">{a.duration_min} min</span>
        )}
      </div>
      <h3 className="relative mt-4 font-heading text-lg font-medium text-slate-100">{a.name}</h3>
      <p className="relative mt-2 flex-1 text-sm leading-relaxed text-slate-400">{a.tagline}</p>
      <span className="relative mt-4 inline-flex items-center gap-1.5 text-sm font-medium" style={{ color: a.color }}>
        {completed ? "View / retake" : "Start free"} <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
